module.exports = __webpack_public_path__ + "static/media/img004.dda788ff.jpg";